/**************************************************
 * Nombre:       Formulario_Suscripcion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AccountCircleOutlined, ApartmentOutlined, CakeOutlined, Mail, WhatsApp} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";


const Formulario_Suscripcion = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'}
                                  dato={'nombres'} {...props} requerido={'Campo requerido'}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'}
                                  dato={'apellidos'} {...props} requerido={'Campo requerido'}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo Electrónico'}
                                  dato={'correo'} {...props} requerido={'Campo requerido'}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={WhatsApp} nombre={'WhatsApp'}
                                  dato={'celular'} {...props} requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={ApartmentOutlined} nombre={'Ciudad'}
                                  dato={'ciudad'} {...props} requerido={'Campo requerido'} opciones={['Pasto', 'Ipiales']}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoFecha Icono={CakeOutlined} nombre={'Fecha de cumpleaños'}
                                  dato={'fechaCumple'} {...props} requerido={'La fecha de cumpleaños es requerida'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Suscripcion